// Соединение берём общее, через initializeDB: сырой openDB(DB_NAME, DB_VERSION)
// заводил на каждый вызов отдельное соединение и никогда его не закрывал.
// Пока версия БД не менялась, это просто копило коннекты; при смене версии
// апгрейд вставал намертво, ожидая их закрытия, и приложение зависало.
import { initializeDB } from '../config/db';
import { WELD_MAP_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

const weldMapService = {
    /**
     * Submit weld map to server
     */
    async submit(weldMap) {
        try {
            const response = await axiosInstance.post('/weld-map/submit', weldMap);
            return response.data;
        } catch (error) {
            console.error('Error submitting weld map:', error);
            throw error;
        }
    },

    /**
     * Save weld map as draft in IndexedDB
     */
    async saveDraft(weldMap) {
        const db = await initializeDB();
        const now = new Date().toISOString();

        const weldMapToSave = {
            ...weldMap,
            status: 'draft',
            updatedAt: now
        };

        if (!weldMapToSave.createdAt) {
            weldMapToSave.createdAt = now;
        }

        await db.put(WELD_MAP_STORE, weldMapToSave);
        return weldMapToSave;
    },

    /**
     * Load weld map by UUID from IndexedDB
     */
    async loadByUuid(uuid) {
        const db = await initializeDB();
        return await db.get(WELD_MAP_STORE, uuid);
    },

    /**
     * Get all weld maps from IndexedDB
     */
    async getAll() {
        const db = await initializeDB();
        return await db.getAll(WELD_MAP_STORE);
    },

    /**
     * Delete weld map from IndexedDB
     */
    async delete(uuid) {
        const db = await initializeDB();
        await db.delete(WELD_MAP_STORE, uuid);
    }
};

export default weldMapService;
